import { Box, Stack, Typography } from '@mui/material';

export interface LegendItem {
  label: string;
  color: string;
  /** A square for bars and areas, a short line with a dot for line series. */
  kind?: 'bar' | 'line';
}

/**
 * The small legend that sits under a chart, aligned right. Replaces MUI X's
 * built-in legend, which is larger and crowds the top of the plot.
 */
export function ChartLegend({ items }: { items: LegendItem[] }) {
  return (
    <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap justifyContent="flex-end">
      {items.map((item) => (
        <Stack key={item.label} direction="row" spacing={0.75} alignItems="center">
          {item.kind === 'line' ? (
            <Box sx={{ position: 'relative', width: 16, height: 10 }}>
              <Box sx={{ position: 'absolute', left: 0, right: 0, top: 4, height: 2, bgcolor: item.color, borderRadius: 1 }} />
              <Box
                sx={{
                  position: 'absolute', left: 4, top: 1, width: 8, height: 8, borderRadius: '50%',
                  bgcolor: 'background.paper', border: 2, borderColor: item.color, boxSizing: 'border-box',
                }}
              />
            </Box>
          ) : (
            <Box sx={{ width: 10, height: 10, borderRadius: '2px', bgcolor: item.color }} />
          )}
          <Typography variant="caption" color="text.secondary">{item.label}</Typography>
        </Stack>
      ))}
    </Stack>
  );
}
